export enum URLS {
  WEBSITE = 'https://firewatch.fund',
  MOCK = '/landscape-poster-mock.jpg',
  ONE_TREE_PLANTED = 'https://onetreeplanted.org',
  YML = 'https://yml.co',
  LINKEDIN = 'https://www.linkedin.com/shareArticle',
  TWITTER = 'https://twitter.com/share',
  FACEBOOK = 'https://www.facebook.com/sharer/sharer.php',
  YOUTUBE_IFRAME_API = 'https://www.youtube.com/iframe_api',
  S3_BUCKET = 'https://firewatch-nft-static.s3.amazonaws.com',
  FIND_RCD = 'https://carcd.org/rcds/find',
  ALL_ABOUT_COOKIES = 'https://allaboutcookies.org',
  STEP_BY_STEP = 'https://medium.com/ymedialabs-innovation/purchasing-an-nft-on-firewatch-56ac428ea51e',
}
